import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFolder,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import "./index.scss";
import '../../../../assets/css/common/document/statusIcon.scss';
import ReactTooltip from 'react-tooltip';
import { useSelector } from "react-redux";

const DocMenus = ({ sortFn, list, _handleSelectedAction, __sidebarActivePacketIndex }) => {

	const selectedFile = useSelector((state) => state.document.fileData);

	const __handleSelectedAction = (index, id) => {
		_handleSelectedAction(id, index);
		//setActiveId(index)
	};

	let activeId = __sidebarActivePacketIndex && __sidebarActivePacketIndex !== undefined ? __sidebarActivePacketIndex : 0

	//   const [tooltipOpen, setTooltipOpen] = useState(false);
	//const [activeId, setActiveId] = useState(0);
	//   const toggle = () => setTooltipOpen(!tooltipOpen);
	return (
		<>
			<ul className="list-unstyled doc-list">
				{list.length &&
					list.map((_val, index) => {
						return (
							<li className={activeId === index ? `active` : ``} key={`doc_${index}`} data-placement="top" >
								<Button
									color="link"
									className="text-start d-inline-flex align-items-center"
									onClick={() => __handleSelectedAction(index, _val._id)}
								>
									<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
										<FontAwesomeIcon icon={faFolder} />
									</span>
									<label>
										<span className="number" data-tip={_val.loan_number}>{_val.loan_number}</span>
										{/*<span className="user-lbl d-block">{_val.user ? _val.user?.lname : _val.admin?.lname}</span>*/}
									
									</label>
									<span className="status-icon ms-auto">
										<span className="icon-cell d-inline-flex">
											{/* <span className={`${_val.is_verified === 1 ? 'text-success rounded-circle' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center `}>
												v
											</span> */}
											<span className={`${_val.is_verified === 1 ? 'text-success rounded-circle' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center `}>
												v
											</span>
										</span>

										<span className="icon-cell d-inline-flex">
											{/* <span className={`${_val.is_correct === 1 ? 'text-success rounded-circle' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center `}>
												c
											</span> */}
											<span className={`${_val.is_correct === 1 ? 'text-success rounded-circle' : 'text-danger'} icon flex-fill d-inline-flex align-items-center justify-content-center `}>
												c
											</span>
										</span>
									</span>
								</Button>
							</li>
						);
					})}
				<ReactTooltip />
			</ul>
		</>
	);
};

export default DocMenus;
